module.exports = __webpack_public_path__ + "img/customer-support.28fab439.png";